<template>
  <div>
    <!--Dialog para confirmação de exclusão-->
    <p-confirm text="Tem certeza que deseja excluir o item de " :entity="this.label" :dialog="dialogConfirm" @confirm="deleteValue('select_editable', editedItem, label, false)" @cancel="closeDialogDelete"></p-confirm>
    <v-form @keyup.native.alt.enter="showActions ? (view === 3 ? saveEditItem() : saveCreateItem(view === 1 ? search_text : editedItem.id_text)) : {}">
      <v-layout>
        <v-flex xs12>
          <v-autocomplete :loading="load" :disabled="disable" :label="label" v-show="view === 1"
                          :search-input.sync="search_text" @change="changeItem"
                          :no-data-text='showActions ? (search_text ? "Pressione \"Alt + Enter\" para adicionar \"" + search_text  + "\"" : "Insira um registro") : "Não possui registros"'
                          clearable @click:clear="$nextTick(() => editedItem.id=null)" 
                          v-model="editedItem.id" :items="props_items" :filter="filterAutocomplete"
                          item-text="id_text" item-value="id" :rules="rules"></v-autocomplete>
          <v-text-field :label="label" v-show="view !== 1" ref="autofocus"
                        v-model="editedItem.id_text"></v-text-field>
        </v-flex>
        <v-flex v-if="showActions">
          <v-flex v-if="(view === 1)" style="min-width: 45px">
            <v-menu
              left
              nudge-top="8"
              content-class="elevation-0 menu_content"
              transition="slide-x-reverse-transition"
              :offset-x="true"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn fab icon small v-on="on" slot="activator" class="mx-0" >
                  <v-icon medium>more_vert</v-icon>
                </v-btn>
              </template>
              <v-tooltip top>
                <v-btn slot="activator" small fab class="mx-0" @click="addNewItem()">
                  <v-icon color="green">add</v-icon>
                </v-btn>
                <span>Incluir</span>
              </v-tooltip>

              <v-tooltip top>
                <v-btn slot="activator" :disabled="search_text === null || editedItem.id === '' || search_text !== editedItem.id_text" small color="grey lighten-4" fab class="mx-0" @click="editSelectItem()">
                  <v-icon color="orange">edit</v-icon>
                </v-btn>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip top>
                <v-btn slot="activator" :disabled="search_text === null || editedItem.id === '' || search_text !== editedItem.id_text" small color="grey lighten-4" fab class="mx-0" @click="dialogDelete(editedItem)">
                  <v-icon color="red">delete</v-icon>
                </v-btn>
                <span>Excluir</span>
              </v-tooltip>
            </v-menu>
          </v-flex>
          <v-flex xs3 v-else style="min-width: 85px">
            <v-btn icon class="mx-0" :loading="loading" :disabled="loading"  @click="saveCreateEditItem()">
              <v-icon color="teal" >check</v-icon>
            </v-btn>
            <v-btn icon class="mx-0" @click="close()">
              <v-icon color="pink" dark>cancel</v-icon>
            </v-btn>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-form>
  </div>
</template>

<style scoped>
  .menu_content {
    padding: 0 10px 10px 10px;
  }
</style>

<script>
  import crud from './../../mixin/crud'
  import PConfirm from './../shared/PConfirm'

  export default {
    name: 'selectEditable',
    mixins: [crud],
    components: {PConfirm},
    props: {
      type: {},
      label: {},
      value: {},
      disable: false,
      load: false,
      props_items: {},
      rules: {},
      showActions: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        // this.editSelectedItem usado para pegar o valor anterior e comparar com o valor atual. ara sair da validade de valor repetido
        editSelectedItem: {},
        entity: 'select_editable',
        search_text: '',
        loading: false
      }
    },
    watch: {
      // Usado o value no watch, para que o editedItem receba o valor quando ele for alterado pelo pai
      value: function (val) {
        let item = this.props_items.find((res) => { return res.id === val }) || ''
        this.editedItem = {id: val || '', id_text: item.id_text || '', type: this.type, active: true}
      }
    },
    mounted () {
      this.editedItem = {id: this.value || '', id_text: '', type: this.type, active: true}
    },
    methods: {
      changeItem (val) {
        this.editedItem.id_text = ''
        if (typeof val === 'number') {
          this.$emit('input', val)
          this.editedItem.id_text = this.props_items.find(res => { return res.id === val }).id_text
        } else {
          this.$emit('input', null)
        }
      },
      // salva o registro ao incluir um  nome de uma categoria ou subcategoria com botões "alt + Enter"
      saveCreateItem (text = '') {
        if (text === null || text === '') {
          this.$store.commit('snackbar/change_values', {text: 'Favor informar o campo "' + this.label + '" para incluir!', color: 'error', dialog: true})
        } else if (this.props_items.filter(a => a.id_text === text).length > 0) {
          this.$store.commit('snackbar/change_values', {text: 'O item "' + text + '" já existe na lista!', color: 'warning', dialog: true})
        } else {
          this.loading = true
          Object.assign(this.editedItem, {id_text: text})
          this.$http.post('api/select_editable', this.editedItem).then(
            (res) => {
              this.editedItem.id = res.body.id
              this.props_items.push(res.body)
              this.$emit('input', res.body.id)
              this.view = 1
              this.loading = false
              this.$store.commit('snackbar/change_values', {text: 'Registro de "' + text + '" incluído com sucesso!', color: 'success', dialog: true})
            }, err => {
              console.log(err)
              this.loading = false
              this.$store.commit('snackbar/change_values', {text: 'Não foi possível incluir o registro, reporte o erro.', color: 'error', dialog: true})
            })
        }
      },
      // salva o registro ao editar um nome de uma categoria ou subcategoria já existente
      saveEditItem (text = this.editedItem.id_text) {
        if (text === null || text === '') {
          this.$store.commit('snackbar/change_values', {text: 'Favor informar o campo "' + this.label + '" para salvar!', color: 'warning', dialog: true})
        } else if (this.props_items.filter(a => a.id_text === text).length > 0) {
          this.$store.commit('snackbar/change_values', {text: 'O item "' + text + '" já existe na lista!', color: 'warning', dialog: true})
        } else {
          this.loading = true
          this.$http.put('api/select_editable/' + this.editedItem.id,
            this.editedItem).then((res) => {
            Object.assign(this.props_items.find((val) => { return val.id === this.editedItem.id }) || {}, res.body)
            this.search_text = res.body.id_text
            this.view = 1
            this.loading = false
            this.$store.commit('snackbar/change_values', {text: 'Registro de ' + this.label + ' editado com sucesso!!', color: 'success', dialog: true})
          }, err => {
            console.log(err)
            this.loading = false
            this.$store.commit('snackbar/change_values', {text: 'Não foi possível editar o registro, reporte o erro.', color: 'error', dialog: true})
          })
        }
      },
      // salva o registro ao incluir um novo nome de uma categoria ou subcategoria através do botão flutuante "incluir"
      saveCreateEditItem () {
        if (this.view === 2) {
          this.saveCreateItem(this.editedItem.id_text)
        } else {
          this.saveEditItem(this.editedItem.id_text)
        }
      },
      editSelectItem () {
        if (this.editedItem) {
          if (this.editedItem.id) {
            this.editSelectedItem = this.props_items.filter(a => a.id === this.editedItem.id)[0]
            this.editItem(this.editSelectedItem)
            this.$nextTick(() => this.$refs.autofocus.focus())
          } else {
            alert('Selecione um item')
          }
        } else {
          alert('Selecione um item')
        }
      },
      // Esse método serve apenas para habilitar o campo para uma nova inclusão de um nome seja de uma categoria ou subcategoria
      addNewItem () {
        this.view = 2
        this.editedItem.id_text = ''
        this.$nextTick(() => this.$refs.autofocus.focus())
      },
      close () {
        this.props_items.map(function (currentValue) {
          if (this.editedItem.id === currentValue.id) {
            this.editedItem.id_text = this.search_text = currentValue.id_text
          }
        }, this)
        this.view = 1
      },
      afterDeleteValue (item) {
        this.editedItem = {id: '', id_text: ''}
        let index = this.props_items.findIndex((element, index, array) => {
          return element.id === item.id
        })
        this.props_items.splice(index, 1)
        this.$emit('input', null)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/PSelectEditable.vue